const baseURL = process.env.VUE_APP_SERVER_URL;

export async function ObterLinkVidaLink({ vinculo }: { vinculo: string }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/VidaLink/ObterLinkVidaLink`,
      query: {
        vinculo
      }
    })
    .then((resp: any) => resp.data)
    .catch((error: any) => {
      globalThis.window.$log.error("ObterLinkVidaLink", error?.message || error);
      const body = error?.response?.data;
      if (body?.Error) return body;
      throw error;
    });
}
